module.exports = __webpack_public_path__ + "img/hint-put-here.d22d630a.png";